// extracted by mini-css-extract-plugin
export var thumbSlide = "ThumbSlider-module--thumbSlide--c4879";
export var thumbSlider = "ThumbSlider-module--thumbSlider--b7ffe";